export const ACCESS_TOKEN_COOKIE = 'local_access_token';
export const COOKIE_OPTIONS = { path: '/' };
